const addressLine = (item) => {
  const locality = [item.postcode, item.city].filter(Boolean).join(" ");
  return [item.street, locality].filter(Boolean).join(", ");
};

const textElement = (document, className, value) => {
  const element = document.createElement("div");
  element.className = className;
  element.textContent = value == null ? "" : String(value);
  return element;
};

export const appendRspoSuggestion = (document, container, item, onSelect) => {
  const button = document.createElement("button");
  button.type = "button";
  button.className = "block w-full px-3 py-2 text-left hover:bg-gray-100 cursor-pointer";
  button.append(
    textElement(document, "text-sm font-medium", item.name),
    textElement(document, "text-xs text-gray-600", addressLine(item)),
  );
  button.addEventListener("click", () => onSelect(item));
  container.append(button);
};

export const renderSelectedRspo = (document, container, item) => {
  const card = document.createElement("div");
  card.className = "rounded border bg-gray-50 px-3 py-2";
  card.append(
    textElement(document, "text-sm font-medium", item.name),
    textElement(document, "text-xs text-gray-600", addressLine(item)),
  );
  container.replaceChildren(card);
};
